import React, { useEffect, useState } from "react";
import { useDebounce } from "react-use";
import { useTranslation } from "react-i18next";

import {
  SInputContainer,
  SInputTitle,
  SInputDescription,
  SInputField,
  SEditIcon,
} from "../styles";
import { useCurrentPortfolio } from "../../../../store";

export const PortfolioName: React.FC = () => {
  const { t } = useTranslation();
  const [value, setValue] = useState("");
  const { setPortfolioName } = useCurrentPortfolio();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    setValue(e.target.value);
  };

  const [, cancel] = useDebounce(
    () => {
      setPortfolioName(value);
    },
    1000,
    [value]
  );

  useEffect(() => {
    cancel();
  }, [cancel]);

  return (
    <SInputContainer>
      <SInputTitle>{t("portfolioEditorName")}</SInputTitle>
      <SInputField
        value={value}
        onChange={handleChange}
        size="small"
        startAdornment={<SEditIcon fontSize="small" />}
        disableUnderline
      />
      <SInputDescription>{t("optional")}</SInputDescription>
    </SInputContainer>
  );
};
